export default {
      id: "search-slim-usage",
      viewBox: "0 0 451 451",
      url: "/assets/svg/" + "sprite.svg#search-slim-usage",
      toString: function () {
        return this.url;
      }
    }